/* eslint-disable indent */
export const log = (level, entry, optionalParameters) => {
  if (process.env.REACT_APP_SENTRY_ENVIRONMENT !== "production") {
    switch (level) {
      case "l":
        console.log(
          `${new Date().toISOString()} >> ${entry}${
            optionalParameters ? " >>" : ""
          }`,
          optionalParameters
        )
        break
      case "w":
        console.warn(
          `${new Date().toISOString()} >> ${entry}${
            optionalParameters ? " >>" : ""
          }`,
          optionalParameters
        )
        break
      case "e":
        console.error(
          `${new Date().toISOString()} >> ${entry}${
            optionalParameters ? " >>" : ""
          }`,
          optionalParameters
        )
        break
      default:
        console.log(
          `${new Date().toISOString()} >> ${entry}${
            optionalParameters ? " >>" : ""
          }`,
          optionalParameters
        )
        break
    }
  }
}
